// extracted by mini-css-extract-plugin
export default {"tx":"_65e8f972b2","line":"f3d4ed629c"};